module.exports = __webpack_public_path__ + "img/e4.88dc6e89.jpg";